import { createContext, createElement, type ReactNode, useContext } from 'react'

export interface Tenant {
  id: string
  slug: string
  name: string
}

const TenantContext = createContext<Tenant | null>(null)

export function TenantProvider({ tenant, children }: { tenant: Tenant; children: ReactNode }) {
  return createElement(TenantContext.Provider, { value: tenant }, children)
}

export function useTenant(): Tenant {
  const ctx = useContext(TenantContext)
  if (!ctx) throw new Error('useTenant must be used within TenantLayout')
  return ctx
}

export function useTenantPath() {
  const { slug } = useTenant()
  return (path: string) => `/${slug}${path}`
}
